/* F06 Do not pick a ring size for the shopper (Website CRO chat, Oct 2026; live 25 Oct on Alex's yes, card rings-open-with-no-size).
   F06 part of the draft's cro-product.js only (spec website-cro\port\F06.md). Loaded with defer from snippets/cro-size-unset.liquid,
   so only on pages where a size starts empty. Works alongside theme.js without changing it. */
(function () {
  'use strict';

  // Load once: a theme editor section reload re-inserts the script tag, and the listeners below are page-wide.
  if (window.__croSize) return;
  window.__croSize = true;

  var CHOOSE = 'Choose a size';

  function unsetPickers() {
    return Array.prototype.slice.call(document.querySelectorAll('product-variants[data-cro-size-unset]'));
  }

  function formOf(picker) {
    return document.getElementById(picker.getAttribute('form-id'));
  }

  function pickerForForm(form) {
    return unsetPickers().filter(function (p) { return formOf(p) === form; })[0] || null;
  }

  function isUnset(form) {
    return !!form && form.hasAttribute('data-cro-size-unset');
  }

  function buttonsFor(form) {
    return Array.prototype.slice.call(document.querySelectorAll('[data-product-add-to-cart-button]')).filter(function (b) {
      return b.form === form;
    });
  }

  function setButtonText(button, text) {
    var target = button.getAttribute('is') === 'loader-button' && button.firstElementChild ? button.firstElementChild : button;
    target.textContent = text;
  }

  function stickySelects(form, position) {
    return Array.prototype.slice.call(document.querySelectorAll('product-sticky-form select[name="option' + position + '"]')).filter(function (s) {
      return s.form === form;
    });
  }

  function init(picker) {
    var form = formOf(picker);
    if (!form) return;
    var position = picker.getAttribute('data-cro-size-unset');
    form.setAttribute('data-cro-size-unset', position);

    // The theme's sticky bar follows the same state: its button reads "Choose a size" and, on desktop, its size list
    // starts on a "Choose a size" line instead of a size nobody chose.
    buttonsFor(form).forEach(function (b) {
      b.setAttribute('data-cro-choose-size', '');
      setButtonText(b, CHOOSE);
    });
    stickySelects(form, position).forEach(function (select) {
      if (!select.querySelector('option[data-cro-placeholder]')) {
        var placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.disabled = true;
        placeholder.setAttribute('data-cro-placeholder', '');
        placeholder.textContent = CHOOSE;
        select.insertBefore(placeholder, select.firstChild);
      }
      select.value = '';
      var shown = document.getElementById(select.getAttribute('data-bind-value'));
      if (shown) shown.textContent = CHOOSE;
    });

    // A size already ticked (browser back/forward restoring the form) counts as chosen.
    var ticked = picker.querySelector('input[name="option' + position + '"]:checked');
    if (ticked) chosen(form, picker, true);
  }

  function prompt(form) {
    var picker = pickerForForm(form);
    if (!picker) return;
    var message = picker.querySelector('.cro-size-message');
    var header = document.querySelector('.shopify-section--header');
    var offset = (header ? header.getBoundingClientRect().height : 0) + 24;
    var top = picker.getBoundingClientRect().top + window.pageYOffset - offset;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
    if (message) {
      message.hidden = false;
      message.textContent = '';
      // Set the words a moment after showing it so screen readers announce it every time.
      window.setTimeout(function () { message.textContent = 'Please choose a size first.'; }, 50);
    }
    var name = 'option' + picker.getAttribute('data-cro-size-unset');
    var first = picker.querySelector('.block-swatch:not(.is-disabled) input[name="' + name + '"]') || picker.querySelector('input[name="' + name + '"]');
    if (first) first.focus({ preventScroll: true });
  }

  // Called once a size has been chosen. If the theme did not announce a variant change (the size tapped is the one
  // already sitting in the hidden id field, or the theme had not loaded the product yet), make it do so now.
  function chosen(form, picker, themeMissedIt) {
    form.removeAttribute('data-cro-size-unset');
    picker.removeAttribute('data-cro-size-unset');
    buttonsFor(form).forEach(function (b) { b.removeAttribute('data-cro-choose-size'); });
    var message = picker.querySelector('.cro-size-message');
    if (message) { message.hidden = true; message.textContent = ''; }
    Array.prototype.slice.call(document.querySelectorAll('option[data-cro-placeholder]')).forEach(function (o) {
      if (o.parentNode && o.parentNode.form === form) o.parentNode.removeChild(o);
    });
    if (themeMissedIt) forceSelect(form, picker, 0);
  }

  function forceSelect(form, picker, tries) {
    if (!picker.product || typeof picker._getVariantFromOptions !== 'function') {
      if (tries < 100) window.setTimeout(function () { forceSelect(form, picker, tries + 1); }, 100);
      return;
    }
    var variant = picker._getVariantFromOptions();
    var master = form.querySelector('[name="id"]');
    if (!variant || !master) return;
    master.value = '';
    picker.selectVariant(variant.id);
  }

  var pending = null;

  // Capture: runs before the theme's own change handler on <product-variants>.
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.name || input.name.indexOf('option') !== 0) return;
    var form = input.form;
    if (!isUnset(form)) return;
    if (input.name !== 'option' + form.getAttribute('data-cro-size-unset')) return;
    var picker = pickerForForm(form);
    if (!picker || pending) return; // a change the theme fires while handling this one is not a new choice
    pending = { event: event,  form: form, picker: picker, source: input.closest('product-variants') || picker, announced: false };
    var mark = function () { if (pending) pending.announced = true; };
    form.addEventListener('variant:changed', mark, { once: true });
    pending.unmark = function () { form.removeEventListener('variant:changed', mark); };
  }, true);

  // Bubble: runs after the theme has handled the same change.
  document.addEventListener('change', function (event) {
    if (!pending || pending.event !== event) return;
    var p = pending;
    pending = null;
    p.unmark();
    chosen(p.form, p.picker, false);
    if (!p.announced) forceSelect(p.form, p.source, 0);
  });

  function stop(event, form) {
    event.preventDefault();
    event.stopImmediatePropagation();
    prompt(form);
  }

  // Window capture runs before the theme, the Globo gift options app and Shopify's own handlers.
  window.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('button[type="submit"], [data-product-add-to-cart-button]') : null;
    if (button && isUnset(button.form)) stop(event, button.form);
  }, true);

  window.addEventListener('submit', function (event) {
    if (isUnset(event.target)) stop(event, event.target);
  }, true);

  function start() {
    unsetPickers().forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
